module.exports = __webpack_public_path__ + "img/email_graphics.b0b1399c.png";